import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_COMPLETE: MijnRoute = {
    path: ':id/resultaat',
    navigationEvent: 'toBeleggenComplete',
    regex: /^\/beleggen\/[^/]+\/resultaat$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/resultaat'
};
